import { ENewNotificationType } from '@enum';
import {
    EEventName,
    ENotificationCategory,
    ENotificationGroup
} from '@xeppt/xeppt-sdk/types/notification';

// TODO: promote to @xeppt/xeppt-sdk EEventName/ENotificationGroup at next SDK publish
// Raw runtime string values emitted by the backend for the wallet purchase/sale
// notifications. These are not yet present as members of the published SDK enums,
// so they are declared and cast locally until the SDK is bumped.
export const EEventNameWalletPurchase = 'wallet_purchase' as unknown as EEventName;
export const EEventNameWalletPurchaseRefunded =
    'wallet_purchase_refunded' as unknown as EEventName;
export const EEventNameWalletSaleReceived = 'wallet_sale_received' as unknown as EEventName;
export const EEventNameWalletSaleRefunded = 'wallet_sale_refunded' as unknown as EEventName;
export const ENotificationGroupPurchases = 'purchases' as unknown as ENotificationGroup;
export const ENotificationGroupSales = 'sales' as unknown as ENotificationGroup;
export const ENotificationGroupGiftCards = 'gift_cards' as unknown as ENotificationGroup;
export const ENotificationGroupSystems = 'systems' as unknown as ENotificationGroup;

export const notificationsByType = {
    [ENewNotificationType.ACCOUNT]: [
        EEventName.EPSCardUnlinked,
        EEventName.BankAccountUnlinked,
        EEventName.BankAccountLinked,
        EEventName.BankAccountLinked,
        EEventName.EPSCardLinked,
        EEventName.GiftCardCancelationApproved,
        EEventName.GiftCardCancelationDeclined
    ],
    [ENewNotificationType.LOGOUT]: [EEventName.UserSuspended, EEventName.UserBlocked],
    [ENewNotificationType.USER]: [EEventName.UserVerified],
    [ENewNotificationType.SUPPORT]: [
        EEventName.SupportTicketNewMessage,
        EEventName.SupportTicketSolved,
        EEventName.SupportTicketStatusChanged
    ],
    [ENewNotificationType.CARD]: [
        EEventName.CardBlocked,
        EEventName.CardCreated,
        EEventName.CardActivated,
        EEventName.CardBalanceLoaded,
        EEventName.CardTransactionDeclined,
        EEventName.CardPinChanged,
        EEventName.CardReplaced,
        EEventName.CardCanceled,
        EEventName.CardFrozen,
        EEventName.CardUnfrozen,
        EEventName.CardTransactionProcessed
    ],
    [ENewNotificationType.BILL]: [
        EEventName.ScheduleBillFailed,
        EEventName.ScheduleBillInsufficient,
        EEventName.ScheduleBillProcessed,
        EEventName.ScheduleBillLimits
    ],
    [ENewNotificationType.TRANSACTION]: [
        EEventName.EFTDepostProcessed,
        EEventName.EFTDepostFailed,
        EEventName.EPSDepositProcessed,
        EEventName.EPSDepositFailed,
        EEventName.BillPaymentProcessed,
        EEventName.EFTTransferFailed,
        EEventName.ETransferRequestProcessed,
        EEventName.ETransferRequestDeclined,
        EEventName.ETransferProcessed,
        EEventName.ETransferFaild,
        EEventName.MoneyRequestReceived,
        EEventName.MoneyRequestDeclined,
        EEventName.MoneyRequestApproved,
        EEventName.PaymentReceived,
        EEventName.RefundApproved,
        EEventName.ScheduleBillProcessed,
        EEventName.ScheduleBillFailed,
        EEventName.ScheduleBillInsufficient,
        EEventName.ScheduleBillLimits,
        EEventName.ScheduleTransferProcessed,
        EEventName.ScheduleTransferFailed,
        EEventName.ScheduleTransferInsufficient,
        EEventName.ScheduleTransferLimits,
        EEventName.ScheduleEFTProcessed,
        EEventName.ScheduleEFTFailed,
        EEventName.ScheduleEFTInsufficient,
        EEventName.ScheduleMoneyRequestLimits,
        EEventName.ScheduleEFTLimits,
        EEventName.ScheduleEFTDepositProcessed,
        EEventName.ScheduleEFTDepositFailed,
        EEventName.ScheduleEFTDepositLimits,
        EEventName.ScheduleEPSDepositProcessed,
        EEventName.ScheduleEPSDepositFailed,
        EEventName.ExternalUserReceiveMoney,
        EEventName.ScheduleEPSDepositLimits,
        // TODO: promote to @xeppt/xeppt-sdk EEventName at next SDK publish
        EEventNameWalletPurchase,
        EEventNameWalletPurchaseRefunded,
        EEventNameWalletSaleReceived,
        EEventNameWalletSaleRefunded
    ],
    [ENewNotificationType.PHONE]: [EEventName.NewPhoneAdded, EEventName.PrimaryPhoneChanged],
    [ENewNotificationType.EMAIL]: [EEventName.NewEmailAdded, EEventName.PrimaryEmailChanged],
    [ENewNotificationType.LOYALTY]: [
        EEventName.LoyaltyUpgradedGold,
        EEventName.LoyaltyUpgradedPlatinum,
        EEventName.LoyaltyDowngradedSilver,
        EEventName.LoyaltyDowngradedGold,
        EEventName.LoyaltyReviewed,
        EEventName.LoyaltyMaintainedGold,
        EEventName.LoyaltyMaintainedPlatinum,
        EEventName.LoyaltyFirstReviewReminderSilver,
        EEventName.LoyaltyFirstReviewReminderGold,
        EEventName.LoyaltyFirstReviewReminderPlatinum,
        EEventName.LoyaltySecondReviewReminderSilver,
        EEventName.LoyaltySecondReviewReminderGold,
        EEventName.LoyaltySecondReviewReminderPlatinum,
        EEventName.InviteAccepted
    ]
};

export const notificationsGroups = {
    [ENotificationCategory.PERSONAL]: [
        EEventName.UserVerified,
        EEventName.NewEmailAdded,
        EEventName.NewPhoneAdded,
        EEventName.PrimaryEmailChanged,
        EEventName.PrimaryPhoneChanged,
        EEventName.BillingAddressChanged,
        EEventName.BankAccountLinked,
        EEventName.BankAccountUnlinked,
        EEventName.EPSCardUnlinked,
        EEventName.EPSCardLinked,
        EEventName.IntercaEmailUpdated,
        EEventName.SupportTicketSolved,
        EEventName.SupportTicketStatusChanged,
        EEventName.InviteAccepted,
        EEventName.SupportTicketNewMessage,
        EEventName.GiftCardCancelationApproved,
        EEventName.GiftCardCancelationDeclined
    ],
    [ENotificationCategory.CARD]: [
        EEventName.CardBlocked,
        EEventName.CardCreated,
        EEventName.CardBalanceLoaded,
        EEventName.CardActivated,
        EEventName.CardTransactionDeclined,
        EEventName.CardTransactionProcessed,
        EEventName.CardPinChanged,
        EEventName.CardFrozen,
        EEventName.CardUnfrozen,
        EEventName.CardCanceled
    ],
    [ENotificationCategory.PAYMENTS]: [
        EEventName.EFTDepostProcessed,
        EEventName.EFTTransferProcessed,
        EEventName.EFTDepostFailed,
        EEventName.EPSDepositProcessed,
        EEventName.EPSDepositFailed,
        EEventName.BillPaymentProcessed,
        EEventName.ETransferProcessed,
        EEventName.ETransferFaild,
        EEventName.EFTTransferFailed,
        EEventName.ETransferRequestProcessed,
        EEventName.ETransferRequestDeclined,
        EEventName.MoneyRequestReceived,
        EEventName.MoneyRequestDeclined,
        EEventName.MoneyRequestApproved,
        EEventName.PaymentReceived,
        EEventName.ExternalUserReceiveMoney,
        EEventName.RefundApproved,
        // TODO: promote to @xeppt/xeppt-sdk EEventName at next SDK publish
        EEventNameWalletPurchase,
        EEventNameWalletPurchaseRefunded,
        EEventNameWalletSaleReceived,
        EEventNameWalletSaleRefunded
    ],
    [ENotificationCategory.SCHEDULE]: [
        EEventName.ScheduleBillProcessed,
        EEventName.ScheduleBillFailed,
        EEventName.ScheduleBillInsufficient,
        EEventName.ScheduleBillLimits,
        EEventName.ScheduleTransferProcessed,
        EEventName.ScheduleTransferFailed,
        EEventName.ScheduleTransferInsufficient,
        EEventName.ScheduleTransferLimits,
        EEventName.ScheduleEFTProcessed,
        EEventName.ScheduleEFTLimits,
        EEventName.ScheduleEFTFailed,
        EEventName.ScheduleEFTInsufficient,
        EEventName.ScheduleMoneyRequestLimits,
        EEventName.ScheduleEFTLimits,
        EEventName.ScheduleEFTDepositProcessed,
        EEventName.ScheduleEFTDepositFailed,
        EEventName.ScheduleEFTDepositLimits,
        EEventName.ScheduleEPSDepositProcessed,
        EEventName.ScheduleEPSDepositFailed,
        EEventName.ScheduleEPSDepositLimits
    ],
    [ENotificationCategory.LOYALTY]: [
        EEventName.LoyaltyUpgradedGold,
        EEventName.LoyaltyUpgradedPlatinum,
        EEventName.LoyaltyDowngradedSilver,
        EEventName.LoyaltyDowngradedGold,
        EEventName.LoyaltyReviewed,
        EEventName.LoyaltyMaintainedGold,
        EEventName.LoyaltyMaintainedPlatinum,
        EEventName.LoyaltyFirstReviewReminderSilver,
        EEventName.LoyaltyFirstReviewReminderGold,
        EEventName.LoyaltyFirstReviewReminderPlatinum,
        EEventName.LoyaltySecondReviewReminderSilver,
        EEventName.LoyaltySecondReviewReminderGold,
        EEventName.LoyaltySecondReviewReminderPlatinum
    ],
    [ENotificationCategory.MARKETING]: [EEventName.MarketingNews]
};

export const notificationsGroupsSettings: Record<ENotificationCategory, ENotificationGroup[]> = {
    [ENotificationCategory.PERSONAL]: [
        ENotificationGroup.UserAddressUpdate,
        ENotificationGroup.UserExternalAccountsUpdate,
        ENotificationGroup.UserInteracUpdate,
        ENotificationGroup.UserProfileUpdate,
        ENotificationGroup.UserSupportRequestUpdate,
        // TODO: promote to @xeppt/xeppt-sdk ENotificationGroup at next SDK publish
        ENotificationGroupGiftCards,
        ENotificationGroupSystems
    ],
    [ENotificationCategory.CARD]: [
        ENotificationGroup.CardCreation,
        ENotificationGroup.CardStatusUpdate,
        ENotificationGroup.CardPinUpdate
    ],
    [ENotificationCategory.PAYMENTS]: [
        ENotificationGroup.PaymentReceive,
        ENotificationGroup.RequestReceive,
        ENotificationGroup.RequestsUpdate,
        ENotificationGroup.BalanceLoads,
        ENotificationGroup.EtransferPayments,
        ENotificationGroup.BalanceWithdraw,
        ENotificationGroup.CardDeposits,
        ENotificationGroup.CardTransactionsFails,
        // TODO: promote to @xeppt/xeppt-sdk ENotificationGroup at next SDK publish
        ENotificationGroupPurchases,
        ENotificationGroupSales
    ],
    [ENotificationCategory.SCHEDULE]: [
        ENotificationGroup.ScheduleBalanceLoads,
        ENotificationGroup.ScheduleBillPayments,
        ENotificationGroup.ScheduleEftWithdraw,
        ENotificationGroup.ScheduleWalletPayments,
        ENotificationGroup.ScheduleWalletRequests
    ],
    [ENotificationCategory.LOYALTY]: [
        ENotificationGroup.LoyaltyReminders,
        ENotificationGroup.LoyaltyUpdates
    ],
    [ENotificationCategory.MARKETING]: [ENotificationGroup.Marketing]
};
